import styled from 'styled-components';
import moment from 'moment';
import { Link } from 'react-router-dom';
import defaultAvatar from '../../../assets/images/icons/user-avater.png';
import { Input, message, Modal } from 'antd';
import { useState } from 'react';
import { submitConversation } from '../../../api/Report';
import ReactMarkdown from 'react-markdown';
import Item from 'antd/lib/list/Item';
import MarkdownIt from 'markdown-it';
import {LinkOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

const mdParser = new MarkdownIt();

const TimeLineContainer = styled.div`
  /* display: grid;
  grid-template-columns: 80px 1fr; */
`;
const UserContainer = styled.div`
  display: inline-block;
`;

const TimeLineContent = styled.div`
  position: relative;
  /* border: 1px solid #2b2b2b; */
  font-size: 14px;
  line-height: 24px;
  border-radius: 4px;
  font-family:HelveticaNeueBold;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
`;

const UserAvatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 12px;
`;
const DateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextContent = styled.div`
  padding: 20px;
  padding-top: 10px;
`;

const Reply = styled.div`
  padding: 5px 15px;
  text-align: right;
  span {
    cursor: pointer;
  }
`;

const DateTimeLine = styled.div`
  font-size: 11px;
  color: #666;
  & > :nth-child(1) {
    margin-right: 5px;
  }
`;

const UserAndAction = styled.div`
  a {
    font-size: 11px;
    color: #18eac4;
    margin-right: 5px;
  }
  span {
    font-size: 11px;
    color: #666;
  }
`;

const getFileName = (url = '') => {
    if (url) {
        const items = url.split('/')
        return items[items.length - 1]
    }
    return url
}

const DescTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0;
`;


const AttachmentLink = styled.a`
  color: #fff;
  &:hover,
  &:focus,
  &:visited {
    color: #fff;
  }
`

const Content = ({ data, onRefresh }) => {
    const { t } = useTranslation();

  return (
    <TimeLineContainer>
      <DateContainer>
        <UserAndAction style={{
          fontSize: '11px',
          color: '#18eac4',
          marginTop:'3px'
        }}>
          {/* <Link to={`/whiteHats/${data.action_from.name}`}> */}
            { data.action_from ? data.action_from.name ?? 'BugRap Team' : 'BugRap Team' }
          {/* </Link> */}

          <span> {data.action_description}</span>
          {/* <div style={{
            paddingBottom: '20px',
          }}
          dangerouslySetInnerHTML={{__html: mdParser.render(data.action_description)}}
          className="detail-markdown custom-html-style" /> */}
        </UserAndAction>
        <DateTimeLine>
          <span>{moment.unix(data.created_at).format('MMM Do')}</span>
          <span>({moment.unix(data.created_at).fromNow()})</span>
        </DateTimeLine>
      </DateContainer>
      <TimeLineContent>
          <div dangerouslySetInnerHTML={{__html: mdParser.render(data.content)}} className="detail-markdown custom-html-style" />
        {/* {data.content} */}
          {
              data.attachments?.length ? (
                  <>
                      {
                          data.attachments.map(attachment => (
                              <div key={attachment.remote_url}>
                                  <AttachmentLink href={attachment.remote_url} target='_blank'>
                                      <LinkOutlined /> {getFileName(attachment.remote_url)}
                                  </AttachmentLink>
                              </div>
                          ))
                      }
                  </>
              ) : null
          }
      </TimeLineContent>
    </TimeLineContainer>
  );
};

export default Content;
